exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ref: https://github.com/css-modules/css-modules/issues/75 */\n/* ref: https://medium.freecodecamp.org/the-100-correct-way-to-do-css-breakpoints-88d6a5ba1862 */\n\n/* Break Point values - we're only implementing up to bp_tablet_landscape_up - larger BP's aren't required (yet?) */\n\n/* Page widths for above break points */\n", ""]);

// exports
exports.locals = {
	"bp_small_phone_only": "(max-width: 320px)",
	"bp_phone_only": "(max-width: 599px)",
	"bp_tablet_portrait_up": "(min-width: 600px)",
	"bp_tablet_landscape_up": "(min-width: 900px)",
	"small_phone_only": "320px",
	"phone_only": "100%",
	"tablet_portrait_up": "600px",
	"tablet_landscape_up": "900px"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules=true&localIdentName=[name]__[local]___[hash:base64:5]!./src/breakpoints.icss
// module id = 19
// module chunks = 0